<div class="top-sticky-message-bar">
  <div class="d-flex h-100 info px-auto pl-3 pr-3 align-items-center">
    @if (isSSO) {
      <div [innerHTML]="'sso_info_text' | i18next: {name: name}"></div>
    }
  </div>
</div>
